<script setup lang="ts">
import AppHeaderUserInfo from 'Modules/AppHeaderUserInfo.vue'
import AppHeaderFilterToggle from 'Modules/AppHeaderFilterToggle.vue'
import ReportSummaryButton from '@/modules/pages/reportDashboard/ReportSummaryButton.vue'
// Imported the specific icon from your local path
import { CircleQuestionIcon } from 'Common/components/elements/icons/Icons'

interface PropTypes {
  isFiltersVisible: boolean
  toggleIsFiltersVisible: () => void
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div class="relative flex items-center justify-between px-5">
    <ReportSummaryButton />

    <div class="flex items-center gap-4">
      <AppHeaderFilterToggle
        :is-filters-visible="props.isFiltersVisible"
        :toggle-is-filters-visible="props.toggleIsFiltersVisible"
      />

      <a
        href="mailto:support@proxim.aero?subject=Feedback%20and%20Support"
        title="Send questions, comments, or ideas to support@proxim.aero"
        aria-label="Contact Support"
        class="flex items-center text-gray-400 transition-colors hover:text-gray-600"
      >
        <CircleQuestionIcon class="h-5 w-5" />
      </a>

      <AppHeaderUserInfo />
    </div>
  </div>
</template>
